// This function allow to reference async chunks
__webpack_require__.u = function(chunkId) {
	// return url for filenames based on template
	return "static/js/" + chunkId + "." + {"13":"9179c4e5","201":"cb84d637","422":"476308b5","705":"cd6d85a7","842":"26a06ef5"}[chunkId] + ".chunk.js";
};